import { ACTION_SET_DATA } from './actionTypes';

const setData = (key, value) => ({ type: ACTION_SET_DATA, key, value });
export default setData;
